<template>
    <el-col :md="10" :class="classes" v-if="showOn" >
        <el-form-item  :class="{ 'item-fome-base': true, 'required': required === true }" :label="label">
            <template v-if="hasDefaultSlot"><slot /></template>
            <template v-else >
                <input 
                    :type="type||'text'" 
                    autocomplete="off"
                    class="el-input__inner" 
                    v-bind:class="{}"
                    :placeholder="placeholder || label" 
                    :value="value"
                    :maxlength="maxlength"
                    @input="$emit('input', $event.target.value)" 
                />
            </template>
            <div class="text-left">
                <label v-if="error" class="text-danger text-left"> {{ error.msg }} </label>
            </div>
        </el-form-item>
    </el-col>
</template>

<script>
export default {
    props: [
        "error",
        "required",
        "value",
        "classes",
        "label",
        "showOn",
        "placeholder",
        "maxlength",
        "type"
    ],
    computed: {
        hasDefaultSlot() {
            return !!this.$slots.default
        }
    },

}
</script>
